import { render } from "./EventsSection.vue?vue&type=template&id=5ad943de&scoped=true"
import script from "./EventsSection.vue?vue&type=script&lang=js"
export * from "./EventsSection.vue?vue&type=script&lang=js"

import "./EventsSection.vue?vue&type=style&index=0&id=5ad943de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad943de"]])

export default __exports__